import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { RxCross2 } from "react-icons/rx"
import { AiOutlinePlus } from "react-icons/ai"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"
import "./css/InvoiceExternalSend.css"

const InvoiceExternalSend = () => {
    const [fromEmail, setFromEmail] = useState("")
    const [fullName, setFullName] = useState("")
    const [invoice, setInvoice] = useState(undefined)
    const [totalAmount, setTotalAmount] = useState(0)
    const [recepients, setRecepients] = useState([])
    const [addRecepientPopup, setAddRecepientPopup] = useState(false)
    const [addRecepientInput, setAddRecepientInput] = useState("")
    const [subjectInput, setSubjectInput] = useState("")
    const [sendLoading, setSendLoading] = useState(false)

    const _crm__token = localStorage.getItem("_crm__token")

    const navigate = useNavigate()

    const { hash } = useParams()

    const fetchEmailAddress = async () => {
        const { data, status } = await axios.post(`${api}/Mailbox/email-address`, { token: _crm__token })

        if (data.success) {
            setFullName(data.name)
            setFromEmail(data.email)
        }
        // Redirect to mailbox - auth token expired
        else if (data.redirect) {
            toast.info("Please link mailbox to send e-mails")
        }
    }

    const calcualteTotal = (invoice) => {
        let total = 0

        const items = invoice.items

        items.forEach(item => {
            total += (item.quantity * item.rate)
        })

        if (invoice.discount) {
            if (invoice.discount.ispercentage) {
                total = total - (total * invoice.discount.value / 100)
            } else {
                total = total - invoice.discount.value
            }
        }

        if (invoice.adjustment) {
            total = total + invoice.adjustment.value
        }

        let tax = 0

        if (invoice.taxdetails) {
            tax = total * invoice.taxdetails.rate / 100
        }

        total = total + tax

        return total
    }

    const fetchInvoice = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-invoice`, { token: _crm__token, hash })

        if (data.success) {
            const total = calcualteTotal(data.invoice)

            setInvoice(data.invoice)
            setTotalAmount(total)
            setRecepients(prev => {
                const copy = JSON.parse(JSON.stringify(prev))
                copy.push({
                    name: data.invoice.customer.firstname + " " + data.invoice.customer.lastname,
                    email: data.invoice.customer.email,
                    protected: true
                })
                return copy
            })
        }
    }

    const invoiceSend = async () => {
        setSendLoading(true)

        const { data, status } = await axios.post(`${api}/Accounting/send-invoice`, { 
            token: _crm__token, 
            hash,
            subject: subjectInput ? subjectInput : `Invoice - INV-${String(invoice.invoiceindex).padStart(6, "0")} | payment for professional services`,
            recepients
        })

        setSendLoading(false)

        if (data.success) {
            navigate("/accounting/invoices")
        } else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchEmailAddress()
    }, [])

    useEffect(() => {
        fetchInvoice()
    }, [hash])

    console.log({ invoice })

    if (invoice === undefined) {
        return (
            <div>Loading...</div>
        )
    }

    return (
        <div className="_9yme _1ikw">
            {addRecepientPopup ? (
                <div className="likes-are" onClick={() => setAddRecepientPopup(false)}>
                    <div className="imbiber-wig" onClick={e => e.stopPropagation()}>
                        <span>Add new recepient</span>
                        <input
                            placeholder="Enter recepient e-mail address"
                            value={addRecepientInput}
                            onChange={e => setAddRecepientInput(e.target.value)}
                        />
                        <div>
                            <button onClick={() => {
                                setRecepients(prev => {
                                    const copy = JSON.parse(JSON.stringify(prev))
                                    copy.push({ email: addRecepientInput })
                                    return copy
                                })
                                setAddRecepientPopup(false)
                                setAddRecepientInput("")
                            }}>Add</button>
                            <button onClick={() => {
                                setAddRecepientPopup(false)
                                setAddRecepientInput("")
                            }}>Cancel</button>
                        </div>
                    </div>
                </div>
            ) : undefined}
            <div className="container">
                <div className="email_to">
                    <h3>Email to {invoice.customer.firstname}</h3>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">From</div>
                    <div>
                        {fullName} &#x3C;{fromEmail}&#x3E;
                    </div>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">Send To</div>
                    <div className="outlying-swan">
                        {recepients.map((item, recepientIndex) => {
                            return (
                                <div key={recepientIndex} className="predry-wean">
                                    <div>{item.name}</div>
                                    {item.name ? (
                                        <span>
                                            &#x3C;{item.email}&#x3E;
                                        </span>
                                    ) : (
                                        <span>{item.email}</span>
                                    )}
                                    {item.protected ? undefined : (
                                        <span className="satiable-zip" onClick={() => setRecepients(prev => {
                                            const copy = JSON.parse(JSON.stringify(prev))
                                            copy.splice(recepientIndex, 1)

                                            return copy
                                        })}>
                                            <RxCross2 />
                                        </span>
                                    )}
                                </div>
                            )
                        })}
                        <div className="rodeos-ice" onClick={() => setAddRecepientPopup(true)}>
                            <AiOutlinePlus />
                        </div>
                    </div>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">Subject</div>
                    <div className="input_">
                        <input  
                            placeholder={`Invoice - INV-${String(invoice.invoiceindex).padStart(6, "0")} | payment for professional services`}
                            value={subjectInput}
                            onChange={e => setSubjectInput(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="lactates-pole">
                <div className="header">
                    Invoice #INV-{String(invoice.invoiceindex).padStart(6, "0")}
                </div>
                <div className="content">
                    <div className="line">
                        Dear {invoice.customer.firstname},
                    </div>
                    <div className="line">
                        Thank you for your business. Your invoice can be viewed, printed and downloaded as PDF from the link below.
                    </div>
                    <div className="candy-axed">
                        <div className="candy-axed_">
                            INVOICE AMOUNT
                        </div>
                        <div className="candy-axed_amount">
                            {invoice.customer.currency.icon}{(Math.round(totalAmount * 100) / 100).toFixed(2)}
                        </div>
                    </div>
                    <div className="grandads-hags">
                        <div className="grandads-hags_">
                            <div className="pistil-haze">Invoice Number</div>
                            <span>INV-{String(invoice.invoiceindex).padStart(6, "0")}</span>
                        </div>
                        <div className="grandads-hags_" >
                            <div className="pistil-haze">Invoice Date</div>
                            <span>{new Date(invoice.invoicedate).toDateString()}</span>
                        </div>
                        <div className="wrestled-ante">
                            <button>View Invoice</button>
                        </div>
                    </div>
                    <div className="regards">
                        Regards,
                        <div>{fullName}</div>
                    </div>
                </div>
            </div>
            <div className="repute-has">
                <button className="ballroom-tab" onClick={() => invoiceSend()}>
                    {sendLoading ? <SpinnerCircular size="14" color="white" /> : "Send"}
                </button>
                <button className="satin-net">
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default InvoiceExternalSend
